import { FormControlLabel, FormGroup, Grid, Switch } from "@mui/material";
import {
  AOV_COLLECTION_COLUMN_STATE,
  aovColIds,
  COLLECTION_COLUMN_STATE,
  invoiceArrColIds,
  PORTFOLIO_COLUMN_STATE_KEY,
  PORTFOLIO_AOV_SHOW,
} from "constant";
import { useState, useContext, FC } from "react";
import { dispatchCustomEvent, getCustomLayout, getItemFromLocalStorage } from "utils";
import GridEventProvider from "components/context/GridEventContext";
import { ColDef, ColumnState } from "ag-grid-community";
import { CollectionRevenueContext } from "../cellRenderer/CollectionRevenueCellRenderer";
import { CustomColDef } from "types/app";
import { AuthProvider } from "pages";

const ToggleAOV: FC<{ getShowAovStatus: (flag: boolean) => void }> = ({ getShowAovStatus }) => {
  const [showAOV, setShowAOV] = useState(() => {
    return getItemFromLocalStorage(PORTFOLIO_AOV_SHOW, false);
  });
  const { gridEvent } = useContext(GridEventProvider);
  const { setCollectionColumns, setAOVCollectionColumns } = useContext(CollectionRevenueContext);
  const authDetail = useContext(AuthProvider);

  const switchArrOrAov = (aovFlag: boolean) => {
    if (gridEvent) {
      const defs = gridEvent?.columnApi
        ?.getAllColumns()!
        .map((x) => x.getColDef())
        .map((def: ColDef & CustomColDef) => {
          if (!(def.toolPanelClass as string[])?.includes("skip_visiable_check")) {
            if (
              invoiceArrColIds.includes(def.colId as string) ||
              aovColIds?.includes(def.colId as string) ||
              def.colId === "deviceAmount3Y"
            ) {
              const switchLogic =
                (aovFlag && invoiceArrColIds.includes(def.colId as string)) ||
                (!aovFlag && aovColIds.includes(def.colId as string));
              return {
                ...def,
                suppressColumnsToolPanel: switchLogic,
                suppressFiltersToolPanel: switchLogic,
                hide: def.downloadable ?? switchLogic,
              };
            } else {
              return def;
            }
          } else {
            if (
              invoiceArrColIds.includes(def.colId as string) ||
              aovColIds?.includes(def.colId as string)
            ) {
              return {
                ...def,
                suppressColumnsToolPanel: true,
                suppressFiltersToolPanel: true,
                hide: true,
              };
            } else {
              return def;
            }
          }
        });
      // dont change code location -- start
      // to prevent setColumnDefs cause sidebar column/filter layout error when column group is expanded
      const columnGroupStates = gridEvent?.columnApi?.getColumnGroupState?.() || [];
      columnGroupStates.forEach((groupState: any) => {
        gridEvent?.columnApi?.setColumnGroupOpened(groupState.groupId, false);
      });
      // need this timeout to ensure the columnGroupClose done.
      setTimeout(() => {
        gridEvent?.api?.setColumnDefs(defs!, "api");
      }, 100);
      // dont change code location -- end
      const layout = getCustomLayout(defs, aovFlag);
      setTimeout(() => {
        const columnToolPanel: any = gridEvent?.api?.getToolPanelInstance("columns");
        columnToolPanel?.setColumnLayout(layout);
      }, 100);
      const filtersToolPanel: any = gridEvent?.api?.getToolPanelInstance("filters");
      filtersToolPanel?.setFilterLayout(layout);
      // column visible check
      const allCollumnState = gridEvent?.columnApi?.getColumnState();
      const visibleArrCols = allCollumnState
        .filter((i) => i.colId?.startsWith("invoiceArr") && !i.hide)
        .map((m) => m.colId);
      const visibleAovCols = allCollumnState
        .filter((i) => i.colId?.startsWith("aov") && !i.hide)
        .map((m) => m.colId);

      if (aovFlag) {
        // for aov checkbox checked
        const arrCheckedColumns = localStorage.getItem(COLLECTION_COLUMN_STATE);
        if (arrCheckedColumns) {
          const parsedArrChecked = JSON.parse(arrCheckedColumns);
          const aovChecked: string[] = [];
          if (parsedArrChecked?.length) {
            parsedArrChecked.map((m: string) => {
              if (m === "deviceAmount3Y") {
                aovChecked.push(m);
              } else {
                const [_prefix, fieldName] = m.split("invoiceArr");
                aovChecked.push(`aov${fieldName}`);
              }
            });
          }
          setAOVCollectionColumns?.(aovChecked);
          localStorage.setItem(AOV_COLLECTION_COLUMN_STATE, JSON.stringify(aovChecked));
        }
        const relatedAovCols: string[] = [];
        visibleArrCols.map((v) => {
          const [_prefix, colName] = v.split("invoiceArr");
          relatedAovCols.push(`aov${colName}`);
        });
        const newState = allCollumnState.map((col) => {
          if (relatedAovCols.includes(col?.colId)) {
            return {
              ...col,
              hide: false,
            };
          }
          if (visibleArrCols.includes(col?.colId)) {
            return {
              ...col,
              hide: true,
            };
          }
          return col;
        });
        gridEvent?.columnApi?.setColumnState(newState as ColumnState[]);
        localStorage.setItem(PORTFOLIO_COLUMN_STATE_KEY, JSON.stringify(newState));
        gridEvent?.columnApi.setColumnsVisible(relatedAovCols, true);
        gridEvent?.columnApi.setColumnsVisible(visibleArrCols, false);
      } else {
        // for arr checkbox checked
        const aovCheckedColumns = localStorage.getItem(AOV_COLLECTION_COLUMN_STATE);
        if (aovCheckedColumns) {
          const parsedAovChecked = JSON.parse(aovCheckedColumns);
          const arrChecked: string[] = [];
          if (parsedAovChecked?.length) {
            parsedAovChecked.map((m: string) => {
              if (m === "deviceAmount3Y") {
                arrChecked.push(m);
              } else {
                const [_prefix, fieldName] = m.split("aov");
                arrChecked.push(`invoiceArr${fieldName}`);
              }
            });
          }
          setCollectionColumns?.(arrChecked);
          localStorage.setItem(COLLECTION_COLUMN_STATE, JSON.stringify(arrChecked));
        }
        const relatedArrCols: string[] = [];
        visibleAovCols.map((v) => {
          const [_prefix, colName] = v.split("aov");
          relatedArrCols.push(`invoiceArr${colName}`);
        });
        const newState = allCollumnState.map((col) => {
          if (relatedArrCols.includes(col.colId)) {
            return {
              ...col,
              hide: false,
            };
          }
          if (visibleAovCols.includes(col.colId)) {
            return {
              ...col,
              hide: true,
            };
          }
          return col;
        });
        gridEvent?.columnApi?.setColumnState(newState as ColumnState[]);
        localStorage.setItem(PORTFOLIO_COLUMN_STATE_KEY, JSON.stringify(newState));
        gridEvent?.columnApi.setColumnsVisible(relatedArrCols, true);
        gridEvent?.columnApi.setColumnsVisible(visibleAovCols, false);
      }
      // refresh sidebar panel
      gridEvent?.api?.refreshToolPanel();
    }
  };
  const handleChange = (_e: any, checked: boolean) => {
    setShowAOV(checked);
    localStorage.setItem(PORTFOLIO_AOV_SHOW, JSON.stringify(checked));
    getShowAovStatus(checked);
    switchArrOrAov(checked);
    dispatchCustomEvent<{ aovFlag: boolean }>("WATCH_ARR_AOV_TOGGLE", {
      aovFlag: authDetail?.toggles?.["viewAov"] ? checked : false,
    });
  };

  return (
    <div style={{ marginLeft: 4 }}>
      <FormGroup>
        {/* <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ whiteSpace: "nowrap" }}>Show dollars as AOV:</div>
          <Grid component="label" container alignItems="center" spacing={1}>
            <Grid item>ARR</Grid>
            <Grid item>
              <Switch
                checked={showAOV}
                onChange={handleChange}
                name="checkedAOV"
                color="primary"
                size="small"
              />
            </Grid>
            <Grid item>AOV</Grid>
          </Grid>
        </div> */}
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={showAOV}
              onChange={handleChange}
              color="primary"
            />
          }
          label="Show dollars as AOV"
          labelPlacement="start"
          style={{
            marginLeft: -10,
            justifyContent: "space-between",
          }}
        />
      </FormGroup>
    </div>
  );
};

export default ToggleAOV;
